var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 8,
    viewBox: "0 0 91 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5118 4.35356C90.707 4.1583 90.707 3.84172 90.5118 3.64646L87.3298 0.464475C87.1345 0.269213 86.8179 0.269213 86.6227 0.464475C86.4274 0.659737 86.4274 0.97632 86.6227 1.17158L89.4511 4.00001L86.6227 6.82844C86.4274 7.0237 86.4274 7.34028 86.6227 7.53554C86.8179 7.73081 87.1345 7.73081 87.3298 7.53554L90.5118 4.35356ZM0.158203 4.5L90.1582 4.50001L90.1582 3.50001L0.158203 3.5L0.158203 4.5Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightShort);
export default __webpack_public_path__ + "static/media/ArrowRightShort.f3e036ce0750c45667a553148f9068a6.svg";
export { ForwardRef as ReactComponent };